
export class MessageRequest {
    messageCode: number;
    message?: string;
    receivers?: string[];
    
    /**
     * 
     * @param messageCode 
     * @param message 
     */
    constructor(messageCode: number, message: string,receivers?: string[]) {
       this.messageCode = messageCode;
       this.message = message;
       this.receivers = receivers;
    }
}